import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { logoutUrl } from '../shared/Links';
import GenericError from '../shared/Errors/GenericError';
import { PsBeaconButton } from '../shared/BeaconRegister';

export default function PrimaryLoggedIn() {
    const logOutFPS = () => {
        window.location.href = logoutUrl;
        const keysToRemove = ['emailInv', 'invitePinNumber', 'lastRequestTime', 'joinginRasHH'];
        keysToRemove.forEach((k) => localStorage.removeItem(k));
        keysToRemove.forEach((k) => sessionStorage.removeItem(k));
    };

    return (
        <Box sx={{ width: '100%', backgroundColor: '#F4F5F6' }}>
            <Box
                sx={{ inlineSize: 'unset', paddingTop: '80px', paddingBottom: '80px' }}
                id="primary-logged-in-error-container"
                className="b-container-content">
                <GenericError
                    title="Somebody else is already logged into the same browser"
                    id="primary-logged-in">
                    <Box sx={{ paddingBottom: '24px' }}>
                        To join this household, the current person should log out. Then use the link
                        from the email to log in and accept your invitation.
                    </Box>
                    <Box>
                        <PsBeaconButton scale="jumbo" id="logout" onClick={() => logOutFPS()}>
                            Log Out
                        </PsBeaconButton>
                    </Box>
                </GenericError>
            </Box>
        </Box>
    );
}
